import React from 'react';
import Hero from './Hero';
import AIXrayAnalysisCTA from './AIXrayAnalysisCTA';
import Features from './Features';
import Services from './Services';
import Testimonials from './Testimonials';
import TrustedBy from './TrustedBy';
import AllInOne from './AllInOne';
import GrowPractice from './GrowPractice';

const Home = () => {
  return (
    <>
      <Hero />
      <AIXrayAnalysisCTA />
      <Features />
      <div className="container flex flex-col items-center gap-12 px-8 py-16 mx-auto md:flex-row">
        <Services />
        <div className="w-full md:w-1/2">
          <img src="/assets/Our Services.webp" alt="Our Services" className="w-full rounded-2xl shadow-lg" />
        </div>
      </div>
      <Testimonials />
      <TrustedBy />
      <AllInOne />
      <GrowPractice />
    </>
  );
};

export default Home; 